module.exports = __webpack_public_path__ + "static/media/PlatoPlanner-logo-white.2c02256a.png";